<template>
    <div class="eval_add">
        <div class="eval_item mb20" v-for="item in dimensionList" :key="item.id">
            <div class="item_tit mb20">{{ item['name' + $lang] }}</div>
            <ul>
                <li class="item_child" v-for="child in item.items" :key="child.id">
                    <p class="child_tit mb10">
                        <cl-overflow-tooltip parent-class-name="child_tit">
                            {{ child['name' + $lang] }}
                        </cl-overflow-tooltip>
                    </p>
                    <p class="child_star">
                        <cl-score
                            v-if="child.type === 'star'"
                            :starNumber="child.number || 5"
                            v-model="child.data"
                        ></cl-score>

                        <el-input
                            v-if="child.type === 'input'"
                            v-model="child.data"
                            :placeholder="$t('common.请输入')"
                        ></el-input>

                        <el-radio-group v-if="child.type === 'radio'" v-model="child.data">
                            <el-radio :label="item2.value" v-for="item2 in radioOptions" :key="item2.value">{{
                                item2.label
                            }}</el-radio>
                        </el-radio-group>

                        <el-select
                            v-if="child.type === 'select'"
                            v-model="child.data"
                            :placeholder="$t('common.请选择')"
                        >
                            <el-option
                                v-for="item2 in child.number"
                                :key="item2"
                                :label="item2"
                                :value="item2"
                            ></el-option>
                        </el-select>
                    </p>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'cl-eval-add',
    props: {
        dimensionList: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            radioOptions: [
                { label: this.$t('common.是'), value: '1' },
                { label: this.$t('common.否'), value: '0' },
            ],
        };
    },
};
</script>

<style scoped lang="scss">
.eval_add {
    .eval_item {
        box-sizing: border-box;
        padding: 20px;
        border: 1px solid #f3f5f9;
        border-radius: 6px;
        &:nth-child(n) {
            background: url('~@/assets/images/report/eval_qu_bg1.png') center top no-repeat;
            background-size: 100% 70px;
            .item_tit {
                color: #3663e1;
            }
        }
        &:nth-child(2n) {
            background: url('~@/assets/images/report/eval_qu_bg2.png') center top no-repeat;
            background-size: 100% 70px;
            .item_tit {
                color: #00b571;
            }
        }
        &:nth-child(3n) {
            background: url('~@/assets/images/report/eval_qu_bg3.png') center top no-repeat;
            background-size: 100% 70px;
            .item_tit {
                color: #d3a500;
            }
        }
        &:nth-child(4n) {
            background: url('~@/assets/images/report/eval_qu_bg4.png') center top no-repeat;
            background-size: 100% 70px;
            .item_tit {
                color: #ff782b;
            }
        }
        &:nth-child(5n) {
            background: url('~@/assets/images/report/eval_qu_bg5.png') center top no-repeat;
            background-size: 100% 70px;
            .item_tit {
                color: #9167ef;
            }
        }
    }
    .item_tit {
        font-size: 16px;
        line-height: 22px;
    }
    .item_child {
        display: inline-block;
        width: calc(33.3% - 30px);
        box-sizing: border-box;
        border-right: 1px solid #e9edf3;
        padding: 0 30px 0 0;
        margin-right: 30px;
        &:nth-child(3n) {
            border: none;
            margin: 0;
        }
        &.input {
            width: 100%;
            border: none;
        }
    }
    .child_tit {
        font-size: 14px;
        line-height: 30px;
        color: $base-font-minor;
    }
    .child_star {
        position: relative;
        .desc {
            position: absolute;
            left: 195px;
            top: 9px;
            font-size: 14px;
            color: $base-font-tip;
        }
    }
}
</style>
